// extracted by mini-css-extract-plugin
export default {"infobutton":"InfoButton_infobutton__uZuCO"};